import Vue from 'vue'
import Vuex from 'vuex'
import navStore from 'store'
import auth from './auth'
//
import OvenConnect from './OvenConnectWs.js'
import app from './main.js'
import api from './helpers/ApiHelper'
import delay from 'delay'

Vue.use(Vuex)

// VUEX
export default new Vuex.Store({
  state: {
    locale: null,
    ovenList: [],
    oven: null,
    connected: false,
    ovenOnline: null,
    debug: null,
    ovenData: {
      state: '?',
      working: '?',
      auto: '?',
      mode: '?',
      ventilation: '?',
      pas: '?',
      estime: '?',
      duration: '?',
      timer: '?',
      total: '?',
      temperatureSetpoint: '?',
      temperature: '?',
      humidity: '?',
      recipeNumber: '?',
      recipeName: '?',
      sensor: '?'
    },
    authLoading: false,
    jwt: '',
    canReconnect: false,
    device: null
  },
  mutations: {

    // set le device
    setDevice(state, device) {
      state.device = device
    },

    // set le debug
    setDebug(state, debug) {
      state.debug = debug
    },

    // peu se reconnecter direct (cas de perte de connexion)
    setCanReconnect(state, canReconnect) {
      state.canReconnect = canReconnect
    },

    // instance de connexion au four
    setOvenOnline(state, ovenOnline) {
      state.ovenOnline = ovenOnline
    },

    // instance de connexion au four
    resetOvenOnline(state) {
      if (state.ovenOnline) {
        state.ovenOnline.kill()
        state.ovenOnline = null
      }
    },

    // défini une donnée du four
    setSingleData(state, keyVal) {
      if (keyVal.val) {
        Vue.set(state.ovenData, keyVal.key, keyVal.val)
      } else {
        Vue.set(state.ovenData, keyVal.key, '?')
      }
    },

    // reset des valeurs de l'interface
    reset(state) {
      state.connected = false
      state.oven = null
      state.ovenData = {
        state: '?',
        working: '?',
        auto: '?',
        mode: '?',
        ventilation: '?',
        pas: '?',
        estime: '?',
        duration: '?',
        timer: '?',
        total: '?',
        temperatureSetpoint: '?',
        temperature: '?',
        humidity: '?',
        recipeNumber: '?',
        recipeName: '?'
      }
      state.canReconnect = false
    },

    // chargement auth
    setAuthLoading(state, authLoading) {
      state.authLoading = authLoading
    },

    // defini la ventilation
    setVentilation(state, ventilation) {
      state.ovenData.ventilation = ventilation + ''
    },

    // set total
    setTotal(state, total) {
      state.ovenData.total = total + ''
    },

    // état de connexion
    setConnected(state, connected) {
      state.connected = connected
    },

    // set la valeur du timer
    setTimer(state, timer) {
      state.ovenData.timer = timer
    },

    setDuration(state, duration) {
      state.ovenData.duration = duration
    },

    // en marche
    setWorking(state, working) {
      state.ovenData.working = working
    },

    // défini la locale
    setLocale(state, langIso) {
      state.locale = langIso
      // applique
      app.$i18n.locale = langIso
    },

    // défini la liste des fours
    setOvenList(state, ovenList) {
      state.ovenList = ovenList
    },

    // défini le four séléctionné
    setOven(state, ovenConfig) {
      state.oven = ovenConfig
    },

    // défini le four séléctionné
    setState(state, ovenState) {
      state.ovenData.state = ovenState
    },
    // défini le mode séléctionné
    setMode(state, mode) {
      state.ovenData.mode = mode
    },
    // set la configne de température
    setTemperatureSetpoint(state, temperatureSetpoint) {
      state.ovenData.temperatureSetpoint = temperatureSetpoint
    },

    /*
    // ajout d'un four
    addOven(state, ovenConfig) {

      // check si l'ip est déjà présente dans la liste des fours
      var duplicate = false
      for (var oven of state.ovenList) {
        if (oven.ip == ovenConfig.ip) {
          duplicate = true
          break
        }
      }
      if (!duplicate) {
        state.ovenList.push(ovenConfig)
        // enregistrement localStorage
        // localStorage.ovenList = JSON.stringify(state.ovenList)
        navStore.set('ovenList', state.ovenList)
      }

      return true
    },
    */

    // applique la température
    setTemperature(state, temperature) {
      state.ovenData.temperature = temperature
    },

    // set je JWT
    setJwt(state, jwt) {
      if (process.env.NODE_ENV === 'development') {
        console.log('JWT', jwt)
      }
      state.jwt = jwt
      api.setToken(jwt)
    }

  },
  actions: {

    // initialise la connexion avec le four
    initOvenOnline(context) {
      // desctruction de l'instance actuelle (si existance)
      context.commit('resetOvenOnline')
      // sécu
      if (!context.state.jwt || !context.state.oven) {
        return
      }

      // nouvelle instance
      var ovenInst = new OvenConnect(context.state.jwt, context.state.oven.id)
      //
      /*
      ovenInst.on(OvenConnect.EVENT_DATA, (data) => {
        context.dispatch('onlineData', data)
      })
      */

      // mise à jour d'une partie des données
      ovenInst.on(OvenConnect.EVENT_UPDATED, (data) => {
        context.dispatch('onlineDataUpdate', data)
      })

      // four selectionne => état de connexion
      ovenInst.on(OvenConnect.EVENT_CONNECTED, async (connected) => {
        context.commit('setConnected', connected)

        // reconnection automatique
        if (!connected) {
          context.commit('setCanReconnect', true)
        }

      })


      // lance la boucle de requette de mise à jour
      // ovenOnline.start()

      context.commit('setOvenOnline', ovenInst)
    },


    // valeur mise à jour depuis le four
    onlineUpdated(context, keyVal) {
      var value = keyVal.val
      switch (keyVal.key) {
        case 'temperature':
          context.commit('setTemperature', value)
          break;
        case '':
          break;
        default:
          console.log('ONLINE UPDATED NOT USE', keyVal)
      }
    },

    // data depuis le four
    onlineData(context, data) {
      context.state.ovenData = data
    },

    // data depuis le four (quelques données seulement)
    onlineDataUpdate(context, data) {
      for (var key in data) {
        context.commit('setSingleData', { key: key, val: data[key] })
      }
    },

    initLang(context) {

      // charge depuis stokage navigateur
      var lang = navStore.get('lang')

      if (!lang) {
        // langue du navigateur
        lang = navigator.language || navigator.userLanguage
        if (lang) {
          lang = lang.substring(0, 2)
        } else { // langue par default
          lang = 'fr'
        }
      }

      // applique
      context.commit('setLocale', lang)
    },


    /*
    // initialise la liste des fours
    initOvenList(context) {
      var ovenList = navStore.get('ovenList')
      if (ovenList) {
        context.commit('setOvenList', ovenList)
      }
    },
    */

    // initialise le four
    initOven(context) {
      var ovenInNav = navStore.get('oven')
      if (ovenInNav) {
        context.commit('setOven', ovenInNav)
      }
    },


    // changement de langue
    changeLang(context, langIso) {
      context.commit('setLocale', langIso)
      // enregistrement dans le stockage
      // localStorage.lang = langIso
      navStore.set('lang', langIso)
    },

    /*
    
        // ajout d'un four
        addOven(context, ovenConfig) {
          // check si l'ip est déjà présente dans la liste des fours
          for (var oven of context.state.ovenList) {
            if (oven.ip == ovenConfig.ip) {
              throw new Error(app.$t('store.addOven_alreadyExists'))
            }
          }
          context.state.ovenList.push(ovenConfig)
    
          // selection automatique
          context.dispatch('selectOven', ovenConfig)
    
          // enregistrement localStorage
          navStore.set('ovenList', context.state.ovenList)
          return true
        },
    
        // modification d'un four
        editOven(context, payload) {
          var ovenEdit_ip = payload.oven_ip
          var ovenConfig = payload.config
          // secu: si modification de l'ip check si la nouvelle ip est déjà présente dans la liste des fours
          if (ovenEdit_ip != ovenConfig.ip) {
            for (var oven of context.state.ovenList) {
              if (oven.ip == ovenConfig.ip) {
                throw new Error(app.$t('store.addOven_alreadyExists'))
              }
            }
          }
          // modification dans la liste selection du four
          var oven = null
          for (var i = 0; i < context.state.ovenList.length; i++) {
            oven = context.state.ovenList[i]
            if (oven.ip == ovenEdit_ip) {
              context.state.ovenList[i] = ovenConfig
              break
            }
          }
    
          // enregistrement localStorage
          navStore.set('ovenList', context.state.ovenList)
    
          // si jamais le four est le four courant (sélectionné), change le four séléctionné (force si même IP)
          if (ovenEdit_ip == context.state.oven.ip) {
            context.commit('setOven', null)
            Vue.nextTick(() => {
              context.commit('setOven', ovenConfig)
            })
          }
    
          //
          return true
        },
            */

    // suppression d'un four
    removeOven(context, id) {

      // si jamais le four est le four courant (sélectionné), le supprime
      if (id == context.state.oven.id) {
        navStore.set('oven', null)
        context.commit('resetOvenOnline')
        context.commit('reset')
      }
      //
      return true
    },



    // chargement de la liste des fours
    loadOvenList(context) {
      return api.get('/clients/me/ovens')
        .then(res => {
          context.commit('setOvenList', res.data)
        })
        .catch(err => {
          console.error(err)
        })
    },

    // selectionne le four, défini le four utilisé
    selectOven(context, ovenConfig) {
      // enregistrement localStorage
      // localStorage.oven = JSON.stringify(ovenConfig)
      navStore.set('oven', ovenConfig)

      // reset des valeurs de l'interface
      context.commit('reset')
      // change le four séléctionné
      context.commit('setOven', ovenConfig)

      // instance de communication
      context.dispatch('initOvenOnline')

    },

    // reconnexion
    reconnect(context) {
      context.commit('setCanReconnect', false)
      // instance de communication
      context.dispatch('initOvenOnline')

    },

    // change la ventilation du four
    pushVentilation(context, newVentilation) {
      return context.dispatch('push', { key: OvenConnect.KEY_VENTILATION, val: newVentilation })
    },

    // change la consigne de température
    pushTemperatureSetpoint(context, newTemperatureSetpoint) {
      return context.dispatch('push', { key: OvenConnect.KEY_TEMPERATURE, val: newTemperatureSetpoint })
    },

    // commence la chauffe
    pushStart(context) {
      return context.dispatch('push', { key: OvenConnect.KEY_START_STOP, val: 1 })
    },

    // arrête la chauffe
    pushStop(context) {
      return context.dispatch('push', { key: OvenConnect.KEY_START_STOP, val: 0 })
    },

    // change l'état du four
    pushState(context, newState = 0) {
      return context.dispatch('push', { key: OvenConnect.KEY_STATE, val: newState })
    },

    // change le mode du four
    pushMode(context, newMode) {
      return context.dispatch('push', { key: OvenConnect.KEY_MODE, val: newMode })
    },


    // lance le début de la chauffe
    startHeat(context) {
      return context.dispatch('push', { key: OvenConnect.KEY_START_STOP, val: '1' })
    },

    // stop la chauffe
    stopHeat(context) {
      return context.dispatch('push', { key: OvenConnect.KEY_START_STOP, val: '0' })
    },



    // changement de la valeur de la minuterie
    pushTime(context, timeValue) {
      return context.dispatch('push', { key: OvenConnect.KEY_DURATION, val: timeValue })
    },

    // envoi une valeur au four
    push(context, keyVal) {
      // sécu, instance de four
      if (!context.state.ovenOnline) {
        throw new Error(app.$t('store.noOvenOnline'))
      }
      //
      context.state.ovenOnline.sendKeyValue(keyVal.key, keyVal.val)
      return true
    },


    // envoi un message au socket
    send(context, message) {
      // sécu, instance de four
      if (!context.state.ovenOnline) {
        throw new Error(app.$t('store.noOvenOnline'))
      }
      //
      return context.state.ovenOnline.send(message)
    },


    // logout
    logout(context) {

      auth.logout().then(() => {
        // retire le JWT
        context.commit('setJwt', null)
        api.resetToken()
      }, (error) => {
        console.error('Sign Out Error', error);
      })


    }

  }
})
